import type { Contact_Tasks } from "@/src/gql/graphql";
import { TASK_CONFIG } from "@/features/tasks/components/TaskConfig";
import { ENHANCED_TASK_DETAIL_CONFIG } from "@/features/tasks/components/EnhancedTaskDetailConfig";
import { useTasksConfigEnhancer } from "@/lib/hooks/api/shared/config-enhancers";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// TASKS ENTITY DEFINITION
// ============================================================================
// Column change: edit features/tasks/components/TaskConfig.ts fields.
// New saved view: add to TASK_CONFIG.savedViews in TaskConfig.ts.
// Custom filter hook: add to TASK_CONFIG.customFilterHooks in TaskConfig.ts.
// ============================================================================

export const tasksEntity = defineEntity<Contact_Tasks>({
  tableConfig: TASK_CONFIG,

  detailConfig: ENHANCED_TASK_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Injects dynamic tag options into fields at render time
  useConfigEnhancer: (config) => useTasksConfigEnhancer({ config: config as any }),
});
